import React from 'react';

const TenantPassportPage = () => {
  return (
    <div className="passport-page" style={{ padding: '20px' }}>
      <h1>My Tenant Passports</h1>
      <div className="card">
        <div className="card-body text-center">
          <h2>Create Your Digital Passport</h2>
          <p>Package your verified data to share instantly with prospective landlords.</p>
          <button className="btn-primary" style={{marginTop: '16px'}}>Compile Passport</button>
        </div>
      </div>
    </div>
  );
};
export default TenantPassportPage;
